import { Box, Flex } from "@radix-ui/themes"
import React from "react"

export interface AvatarProps {
    name: string,
    style?: React.CSSProperties,
    classes?: string
}

export default function Avatar(props: AvatarProps) {
    const {name, style, classes} = props
    return (
      <Flex align={'center'} justify={'center'} className={`rounded-full mr-5 border ${classes}`} width={"40px"} height={"40px"} style={{backgroundColor: 'white', ...style}}>
                  {name[0].toUpperCase()}
              </Flex>
    )
}